import { env } from "@canucci/base/env";
import { normalizeBaseUrl } from "@canucci/base/url";
import { client as discoveryClient } from "./openapi/discovery/client.gen";
import { parseMfaStepUpError } from "@canucci/base/auth/mfaStepUpError";
import { notifyMfaStepUpRequired } from "@canucci/base/auth/mfaStepUpSignal";
import { getAuth } from "firebase/auth";

let isInitialized = false;

export function initDiscoveryClient() {
  if (!isInitialized) {
    discoveryClient.setConfig({
      baseUrl: normalizeBaseUrl(env.VITE_API_URL as string),
      throwOnError: true,
    });
    // Associate refusals with the request's identity and route, not the state when it finishes.
    const contexts = new WeakMap<Request, { userId?: string; path: string }>();
    discoveryClient.interceptors.request.use((request) => {
      contexts.set(request, {
        userId: getAuth().currentUser?.uid,
        path: window.location.pathname + window.location.search,
      });
      return request;
    });
    discoveryClient.interceptors.error.use((error, response, request) => {
      const detail = response?.status === 403 ? parseMfaStepUpError(error) : null;
      const context = request ? contexts.get(request) : undefined;
      if (
        detail &&
        context?.userId &&
        context.userId === getAuth().currentUser?.uid &&
        context.path === window.location.pathname + window.location.search
      ) {
        notifyMfaStepUpRequired(detail, { userId: context.userId });
      }
      return error;
    });
    isInitialized = true;
  }

  return discoveryClient;
}
